import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine2Footnote3Center extends ITextBoxProps {}

export const TextBoxMaxLine2Footnote3Center = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.Footnote3,
  alignment = TextAligning.Center,
  maxLines = 2,
  ...rest
}: ITextBoxMaxLine2Footnote3Center): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    alignment={alignment}
    maxLines={maxLines}
    {...rest}
  />
)
